import { produce } from 'immer'
import { OrganizationIntegrationListResponse } from 'src/models/organizationIntegration.models'
import {
  GET_ORG_INTEGRATIONS_SUCCESS,
  GetOrgIntegrationsActions,
} from 'src/queries/organizations/integrations/integrations.actions'

export interface OrgIntegrationsState {
  isLoaded: boolean
  listResponses: Record<string, OrganizationIntegrationListResponse> | undefined
}

export const initialState: OrgIntegrationsState = {
  isLoaded: false,
  listResponses: undefined,
}

export type Actions = GetOrgIntegrationsActions

const OrgLevelIntegrationsReducer = (
  state: OrgIntegrationsState = initialState,
  action: Actions,
): OrgIntegrationsState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_ORG_INTEGRATIONS_SUCCESS: {
        draft.isLoaded = true
        draft.listResponses = action.payload.organizationConnections.reduce(
          (acc, curr) => ({
            ...acc,
            [curr.connectionToken]: curr,
          }),
          {},
        )
        return draft
      }
    }
  })
}

export default OrgLevelIntegrationsReducer
